import UserActionTypes  from './user.types';
import { handleSignInFailure, handleSignInSuccess } from './user.util';

const INITIAL_STATE = {
    currentUser: null,
    error: null,
    userIsAdmin: false
}


const userReducer = (state = INITIAL_STATE, action) =>  {
    switch (action.type) {
        case UserActionTypes.SIGN_IN_SUCCESS:
            return {
                ...state,
                currentUser: handleSignInSuccess(action.payload),
                error: null
            };

        case UserActionTypes.SIGN_IN_FAILURE:
        case UserActionTypes.SIGN_OUT_FAILURE:
            return {
                ...state,
                error: handleSignInFailure(action.payload)
            };
        
        case UserActionTypes.SIGN_OUT_SUCCESS:
            return {
                ...state,
                currentUser: null,
                error: null
            };   

        default:
            return state;
    }

}

export default userReducer;